export default __webpack_public_path__ + "static/LM-34-740b881b7217922e381dfb5c06073774.webp";